import ImageSB, { ImageSBProps } from '@/components/atoms/image/ImageSB';
import { LinkButtonProps } from '@/components/atoms/linkButton';
import LinkButtonSB, {
  LinkButtonSBProps,
} from '@/components/atoms/linkButton/LinkSB';
import RichTextFieldSB, {
  RichTextFieldSBProps,
} from '@/components/atoms/richTextField/RichTextFieldSB';
import { BlockComponentModel } from '@/components/cms/types/blok-component';
import { SECTION_NAMES } from '@/components/integrations/trackingScripts/constants';

import { BlockWrapper } from '@/features/utils/BlockWrapper';

import { HeroWithSearch } from './HeroWithSearch';

export type HeroLinksProps = {
  links: LinkButtonSBProps[];
};

export type HeroWithSearchStrapiProps = {
  title: string;
  description: RichTextFieldSBProps;
  image: ImageSBProps;
  links: LinkButtonSBProps[];
  searchWithin?: 'faq' | 'all';
};

export function Links({ links }: HeroLinksProps) {
  function modifyFirstLinkProps(index: number): Partial<LinkButtonProps> {
    if (index === 0) {
      return {
        variant: 'filled',
        color: 'primary',
      };
    }

    return {
      variant: 'outlined',
      color: 'secondary',
    };
  }

  return (
    <div className='flex w-full flex-wrap gap-6'>
      {links.map((link, index) => (
        <LinkButtonSB
          key={link.url}
          block={link}
          inner={{
            classNames: { root: 'w-full sm:w-auto' },
            ...modifyFirstLinkProps(index),
          }}
        />
      ))}
    </div>
  );
}

export function HeroWithSearchStrapi({
  block,
}: BlockComponentModel<HeroWithSearchStrapiProps>) {
  const { title, description, image, links, searchWithin } = block;

  return (
    <BlockWrapper
      theme='dark'
      data-tracker-section={SECTION_NAMES.HERO_WITH_SEARCH}
    >
      <HeroWithSearch
        searchWithin={searchWithin}
        image={<ImageSB block={image} />}
        links={<Links links={links} />}
        title={title}
        description={
          description ? <RichTextFieldSB block={description} /> : undefined
        }
      />
    </BlockWrapper>
  );
}
